import { createContext } from 'react';

const GalleryContext = createContext({
  galleryId: null,
  captionEnabled: true,
  captionPosition: 'bottom',
  captionAppearance: 'static'
});

export default GalleryContext;
